import { formatDateTime, normalizeTime, systemUses24HourTime } from '@app/utils'
import { useCallback } from 'react'

export interface UserPreferences {
	getUserPreferredTime: (date: Date | string | number) => string
}
export function getUserPreferences() {
	return { prefer24HourTime: systemUses24HourTime() }
}
